<template>
  <div class="whole">
    <el-card>
      <div slot="header">
        <h3>{{ $t("button.Compute") }}</h3>
      </div>
      <el-row :gutter="12">
        <el-col :span="10">
          <el-card shadow="always">
            <h3>{{ $t("tips.Compute") }}</h3>
            {{ $t("tips.Compute1") }}<br/><br/>
            {{ $t("tips.Compute2") }}<br/><br/>
            {{ $t("tips.Compute3") }}<br/><br/>
          </el-card>
        </el-col>

        <el-col :span="14">
          <el-card class="yearCalculate">
            <el-select v-model="valueYear" :placeholder="$t('placeholder.Year2')" style="margin-right: 20px">
              <el-option
                  v-for="item in optionsYear"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label">
              </el-option>
            </el-select>

            <el-button type="primary" @click="Calculate(valueYear)">{{ $t("button.Compute") }}</el-button>
          </el-card>
        </el-col>
      </el-row>
    </el-card>



  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "calculateScore",
  data(){
    return{
      optionsYear: [],//"年份"下拉列表
      valueYear:''
    }
  },
  methods:{
    Calculate(valueYear){
      if(valueYear == ''){
        if(this.$i18n.locale==='cn'){
          alert("请选择年份")
        }else{
          alert("Please choose year")
        }
      }
      request.get('calculate/oneYear?toSave=true&year='+valueYear).then(res => {
        if(res.statusText==="OK"){
          if(this.$i18n.locale==='cn'){
            alert("提交成功！计算全部数据将耗费一段时间，请等待约十分钟后进行数据查询")
          }
          else{
            alert ("Submission successful! It will take a while to calculate all the data, please wait about ten minutes before the data query occurs")
          }
        }
        else{
          if(this.$i18n.locale==='cn'){
            alert("指标分数计算失败！")
          }
          else{
            alert ("Failed to calculate the index score!")
          }
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted() {
    this.optionsYear= JSON.parse(window.sessionStorage.getItem('years'))
  }
}
</script>

<style scoped>
@import "~@/assets/css/sameCss.css";
.yearCalculate{
  margin-top: 60px;
}
</style>